import { render, staticRenderFns } from "./SchemePension.vue?vue&type=template&id=22f772c5&scoped=true&"
import script from "./SchemePension.vue?vue&type=script&lang=js&"
export * from "./SchemePension.vue?vue&type=script&lang=js&"
import style0 from "./SchemePension.vue?vue&type=style&index=0&id=22f772c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f772c5",
  null
  
)

export default component.exports